import { useRef } from 'react';

// §2.6 Tabs: underline in accent. items: [{ id, label, count? }]. Arrow keys move between tabs (roving tabindex).
// scroll (OUT-2): on a phone the bar scrolls sideways inside itself when its tabs are wider than the screen (Admin's ten).
export default function Tabs({ items, value, onChange, label, scroll = false }) {
  const refs = useRef({});
  const move = (i, d) => {
    const n = items[(i + d + items.length) % items.length];
    onChange?.(n.id); refs.current[n.id]?.focus();
  };
  return (
    <div className={`ui ui-tabs${scroll ? ' ui-tabs--scroll' : ''}`} role="tablist" aria-label={label}>
      {items.map((t, i) => (
        <button key={t.id} ref={el => { refs.current[t.id] = el; }} type="button" role="tab" className="ui-tab"
          aria-selected={t.id === value} tabIndex={t.id === value ? 0 : -1}
          onClick={() => onChange?.(t.id)}
          onKeyDown={e => { if (e.key === 'ArrowRight') move(i, 1); if (e.key === 'ArrowLeft') move(i, -1); }}>
          {t.label}{t.count != null && <span className="ui-tab__count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
